

export enum StepperStepState {
  Progress = 'stepProgress',
  Completed = 'stepCompleted',
  Inactive = 'stepInactive',
}